import projectConfig from 'config';

export default {
  sizes: {
    graphWindowLeftPadding: 45,
    nodeWidth: 210,
    nodeInnerPadding: 15,
    nodeHeaderHeight: 100,
    edgeLabelBoxHeight: 50,
    edgeOffsetInNode: 20,
    edgeLabelInnerBoxHeight: 40,
    columnSize: 270,
    nodeHorizontalSpacing: 60,
    nodesVerticalSpacing: 30,
    addNodeIconWidth: 20,
    addNodeIconHeight: 20,
    temporaryNodeHeight: 40,
    attachmentIconSize: 15,
    attachmentIconSpacing: 10,
    attachmentBoxSize: 25,
    columnMaxHeight: 1000,
    layerSpacing: 60,
    highlightStrokeWidth: 3,
  },
  files: {
    types: ['image', 'audio', 'video', 'text', 'file'],
    extensionMapping: {
      image: ['png', 'jpg', 'jpeg', 'svg'],
      audio: ['mp3'],
      video: ['mp4'],
      text: ['doc', 'txt', 'docx'],
    },
  },
  nodeData: {
    maxButtons: 8,
  },
  /*
   * What a node is. The graph owns this list - these are its names, spelled the
   * same way, because they travel as strings.
   */
  nodeTypes: {
    message: 'MESSAGE',
    operatorTransfer: 'OPERATOR_TRANSFER',
  },
  rootNodeId: 0,
  messageDefaultText: {
    [projectConfig.localeValues.english]: 'New Message'
  },
  graphMoveTriggerArea: 100,
  graphBaseMoveSpeed: 12
};



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/config.js